import { render, staticRenderFns } from "./itineraries.vue?vue&type=template&id=2b4af550&scoped=true&"
import script from "./itineraries.vue?vue&type=script&lang=js&"
export * from "./itineraries.vue?vue&type=script&lang=js&"
import style0 from "./itineraries.vue?vue&type=style&index=0&id=2b4af550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4af550",
  null
  
)

export default component.exports